/**
 * An icon button with a count on it — the header's bell and messages.
 *
 * `label` is the tooltip **and** the `aria-label`, required for the same reason
 * as `RowActions`': an icon with a number on it is otherwise an unnamed button
 * to a screen reader. Zero shows no badge; over 99 shows "99+".
 */
import type { MouseEvent, ReactNode } from 'react';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export interface BadgeIconButtonProps {
  label: string;
  icon: ReactNode;
  count: number;
  onClick: (event: MouseEvent<HTMLElement>) => void;
}

export function BadgeIconButton({ label, icon, count, onClick }: BadgeIconButtonProps) {
  return (
    <Tooltip title={label}>
      <IconButton color="inherit" onClick={onClick} aria-label={label}>
        <Badge badgeContent={count} color="error" max={99}>
          {icon}
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
